import { useMutation } from '@tanstack/react-query';

import type {
  CreateTerminalPaymentParams,
  CreateTerminalPaymentResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateTerminalPaymentMutation = () =>
  useMutation({
    mutationFn: ({ url, data }: CreateTerminalPaymentParams) =>
      HttpClient.request<CreateTerminalPaymentResponse>({
        method: 'POST',
        url,
        data,
      }),
  });
